import { ASSET_PREFIX } from 'utils/constants';
import RoundedButton, { ColorStyle } from 'components/RoundedButton';
import { useState } from 'react';
import Chevron from 'components/Chevron';

const PlantSeaTreeSection = ({ ctaHandler }) => {
  const [showFullDetails, setShowFullDetails] = useState(false);

  return (
    <div className="container">
      <img
        className="image"
        src={`${ASSET_PREFIX}/images/iceland-raffle/plant-mangrove.jpg`}
        alt="Lifting lowering down into volcano"
      />

      <div className="contentSide">
        <div className="contentContainer">
          <div className="paddedMaxWidthContainer">
            <h3 style={{ marginBottom: '0.2em', textAlign: 'left' }}>
              Plant A Sea <strong>Tree</strong>
            </h3>
            <p style={{ fontStyle: 'italic', fontSize: '1.3em' }}>
              with every entry
            </p>

            <p>
              For each entry into this raffle, we donate a Mangrove tree to our charity partner <a href="https://sea-trees.org" target="_blank">SeaTrees</a>. Help offset your carbon footprint!
              { !showFullDetails && (
                <span onClick={() => setShowFullDetails(true)} className="viewMoreLink">
                  See&nbsp;more
                  <Chevron
                    direction="right"
                    style={{
                      marginLeft: '0.8em',
                      verticalAlign: 'middle',
                      display: 'inline',
                      fontSize: '1.1em',
                    }}
                  />
                </span>
              )}
            </p>

            { showFullDetails && (
              <p>
                SeaTrees makes it easy for anyone who cares about the ocean (don’t we all) to directly support communities planting and protecting blue-carbon coastal ecosystems. The most effective way to suck carbon out of the atmosphere - Period.
                <span onClick={() => setShowFullDetails(false)} className="viewMoreLink">
                  <Chevron
                    direction="left"
                    style={{
                      marginRight: '0.8em',
                      verticalAlign: 'middle',
                      display: 'inline',
                      fontSize: '1.1em',
                    }}
                  />
                  See&nbsp;less
                </span>
              </p>
            )}

            <a href="https://sea-trees.org" target="_blank">
              <img
                src={`${ASSET_PREFIX}/images/iceland-raffle/sea-trees.png`}
                alt="SeaTrees by Sustainable Surf logo"
                style={{
                  width: '200px',
                }}
              />
            </a>
          </div>
        </div>
      </div>

      <style jsx>
        {`
        .container {
          width: 100%;
          display: flex;
        }
        
        .image {
          object-fit: cover;
          height: 100%;
          max-height: 700px;
        }
        
        .container>* {
          width: 50%;
        }
        
        .contentSide {
          display: flex;
          align-items: center;
        }
        
        .paddedMaxWidthContainer {
          margin: auto;
          align-items: flex-end;
          text-align: right;
          padding: 75px 2em 40px;
          max-width: 500px;
        }
        
        .viewMoreLink {
          cursor: pointer;
          font-weight: 800;
          margin-left: 1em;
        }
        
        .ctaContainer {
          width: 100%;
          margin: 3em 0 1em;
          text-align: right;
        }
        
        @media(max-width: 800px) {
          .paddedMaxWidthContainer {
            padding-left: 0.5em;
            padding-right: 0.5em;
            text-align: left;
            align-items: flex-start;
            padding: 40px 1em;
          }
          
          .image {
            // Fixes bug on physical iOS device where parent section was filled in image.
            height: auto;
            max-height: 300px;
          }
          
          .container {
            flex-direction: column;
          }
          
          .container>* {
            width: 100%;
          }
          
          .contentContainer {
            margin: 0 auto;
          }
          
          .ctaContainer {
            text-align: center;
          }
        }
      `}
      </style>
    </div>
  );
};

export default PlantSeaTreeSection;
